import $ from 'jquery';

$(() => {
  const $selectField = $('.custom-field-select');
  $selectField.change(function () {
    if ($(this).val() === '') {
      $(this).addClass('empty');
    } else {
      $(this).removeClass('empty');
    }
  });
  $selectField.change();
  $selectField.find('option[value=""]').attr('disabled', 'disabled');
});
